import { type ReactNode } from 'react';
import { useAuth } from '@/hooks/use-auth';
import { BonusHistoryModal } from './bonus-history-modal';
import { useRaceHistory, type RaceClaim } from '../hooks/use-bonus-history';
import { RaceHistoryRow } from './race-history-row';

type Props = { open: boolean; onClose: () => void };

const TH =
  'pb-3 text-left text-[10px] font-medium uppercase tracking-wider text-text-tertiary/60';

const HEAD_LABELS = ['Ciclo', 'Fechas', 'Ganador', 'Premio', 'Estado'];

function Head(): ReactNode {
  return (
    <thead>
      <tr>
        {HEAD_LABELS.map((l) => (
          <th key={l} className={TH}>
            {l}
          </th>
        ))}
      </tr>
    </thead>
  );
}

function Table({
  items,
  userId,
}: {
  items: RaceClaim[];
  userId: string;
}): ReactNode {
  return (
    <table className="w-full min-w-[34rem] text-left">
      <Head />
      <tbody>
        {items.map((c) => (
          <RaceHistoryRow key={c.id} c={c} userId={userId} />
        ))}
      </tbody>
    </table>
  );
}

export function RaceHistoryModal(p: Props): ReactNode {
  const { user } = useAuth();
  const { data, isLoading } = useRaceHistory(p.open);
  const items = data?.items ?? [];
  return (
    <BonusHistoryModal
      open={p.open}
      onClose={p.onClose}
      title="Histórico Bonus de velocidad"
      loading={isLoading}
      empty={!isLoading && items.length === 0}
      emptyLabel="Sin carreras todavía"
    >
      <Table items={items} userId={user?.id ?? ''} />
    </BonusHistoryModal>
  );
}
